import React from 'react';

import {ListRadio} from './ListRadio';

/**
 * A utility {@link ListRadio} component that is used to set a `boolean` in a form.
 * These options are displayed horizontally and wrap if needed.
 *
 * This component must be used within a <Formik> component.
 *
 * @param {object} param0
 * @param {string} param0.name The name of the field to use in the form.
 * @param {React.ReactNode?} param0.label The (optional) label to display above the field.
 * @param {React.ReactNode?} param0.trueLabel The label to use for the `true` value, or 'Yes' by default.
 * @param {React.ReactNode?} param0.falseLabel The label to use for the `false` value, or 'No' by default.
 */
export const BoolRadio = ({name, label, trueLabel, falseLabel}) => {
    return (
        <ListRadio
            name={name}
            label={label}
            horizontal
            options={[
                {value: true, label: trueLabel || 'Yes'},
                {value: false, label: falseLabel || 'No'},
            ]}
        />
    );
};
